// Generated from explicitly reviewed Batch 1 workforce UI strings.
// Technical identifiers and Philippine payroll terms intentionally remain unchanged.
export const batch1En = {
  "00040bab8a78": "Work",
  "0022a3e10caa": "Save Settings",
  "00eb6118aa8c": "Start Selling",
  "00ef3a724f65": "Count each payment method and enter the amounts you see:",
  "01df8e3c852a": "Orphans (parent deleted)",
  "01f09d033582": "Employee*",
  "029b40abb2b1": "e.g. 0004829145",
  "03781ceef83d": "Select a completed attendance record",
  "03e2ba65ef8e": "No payslips available for this month.",
  "042c862e4467": "Try again",
  "048188f452d4": "Payroll This Month",
  "05882967d7f8": "Present Today",
  "05b1368a3a3a": "Approved OT",
  "06709170d095": "Late Minutes",
  "06ad8947fca5": "Expected Cash",
  "0755a0dcc6b2": "e.g. 30000",
  "0755e0e4e2bd": "Detailed employee attendance timeline, status, and owner approval actions.",
  "0756876bdffa": "Full Name *",
  "075d521f7323": "Approved Days",
  "0764e6ebae1b": "Est Pay",
  "0789dc9c5a6a": "Opening Float (cash in drawer at start)",
  "079711ea16f3": "Employee",
  "07fcdbd896a2": "Total Employees",
  "08189b0386c8": "Working Now",
  "082bc378cd60": "Month",
  "08aeea7adb7f": "inv)",
  "08ca0722e1e6": "Revoke biometric",
  "092f9dd0a820": "Close & Save Z-Report",
  "09509cdf6759": "Open Shift",
  "0999bb9a8a81": "Early leave minutes",
  "0ac1f92dafde": "My Attendance",
  "0bc42f0bd0f1": "Employer share (SSS+PH+HDMF)",
  "0c56dbea8b56": "No leave requests for this filter.",
  "0c5bc1ae01ce": "Shifts",
  "0c63e27ff3bc": "Biometric / Access Credentials",
  "0cf1f544b8e0": "GPS/location",
  "0d16c6e19d1f": "Emergency Contact",
  "0e7b9960126c": "Override Reason:",
  "0fd159793490": "Gross Sales",
  "10dca9add4f6": "Search name, role, department, code…",
  "134fad54d6c5": "· exp",
  "156ce256cf91": "No live attendance records for this date.",
  "158f3da59275": "Weekly",
  "170a28a9db6d": "Period",
  "174a464e2022": "Save Adjustment",
  "1776fa32f23e": "GPS",
  "1798b3ba42ee": "Completed",
  "18e10e9e589f": "New Employee",
  "1929b59a2c7a": "Employees with Payroll Activity",
  "1a043363d06f": "Daily Attendance Details ·",
  "1af75126f6bf": "Pick file",
  "1b485b9e171b": "Timesheets",
  "1b60380406cd": "Assigned area",
  "1c7c77b27543": "Start:",
  "1c9a7a0c6e70": "Search employee",
  "1d1a6f070303": "Manual Override",
  "1d55271669a9": "Performance Score (0-100)",
  "1e2c05f5bacd": "No shifts yet. Open your first shift from the POS page.",
  "1e62856f241a": "No attendance logs for this range.",
  "1f77e83907c4": "Choose...",
  "220e06ba2fee": "Out",
  "2277adf26882": "Role / Position *",
  "231bdaee7939": "Course*",
  "237003634970": "Payroll Review",
  "23bd7dfc67c2": "Employee ID",
  "23d0c59c035a": "Closed Shifts",
  "24345a14377f": "Today",
  "24b572840e97": "Farm Safety, Vaccination Procedures…",
  "24ce812e7163": "Work Completed",
  "2602fe1c7df1": "Gross monthly pay (₱)",
  "26ede189a778": "Hourly Rate",
  "27848f34b1ed": "Attendance-based pay ·",
  "27d5482eebd0": "h",
  "27d9f7d0f448": "Break End (ISO or HH:MM)",
  "27eeb7a291bf": "Rejected",
  "29353c2b2528": "Monthly Salary",
  "2a206d915208": "Completed Field Mode tasks",
  "2ac82da485ed": "Total Team",
  "2af30b2cf622": "Approval notes",
  "2b03b59293b6": "Reject",
  "2c32db022782": "Complete day-level attendance summary, break computation, overtime, and owner controls.",
  "2c3cafa4db3f": "File",
  "2d350acabd06": "Attendance ID:",
  "2db74df2c056": "e.g. Morning shift, refilled coins",
  "2dd1098a9b10": "Open POS Shift",
  "2ddd2d78ecfb": "Leave Report",
  "2f905322013e": "Shift Detail",
  "2f9a6ef20587": "PhilHealth 2.5%",
  "2fdc620768b1": "Mark enrolled now",
  "2fe22cb4982c": "NET PAY",
  "300b6ef0cdd8": "Document type",
  "3168162b6ccd": "Employee Salary Rates",
  "3174c06b9dad": "13th Month Accrual",
  "3197cbcce5dd": "Attendance Reports",
  "3198fe550382": "Gross basic pay (₱)*",
  "319a2b6e851d": "Counted",
  "31b1667fa635": "Currently Open",
  "31d4ba32a2e0": "Requested hours",
  "31e6ef3947c6": "Break Start",
  "327b7992b55e": "Late minutes",
  "33906a7dfdec": "OPEN",
  "33bbad56533f": "Feeding records",
  "33ce417454bf": "Loading…",
  "34115ad627a6": "Development Mode: Reset today's attendance is enabled for Owner/Admin testing.",
  "34465c52157a": "Payslip",
  "346714c46c07": "Employee Calendar",
  "34a4dd3cb9f3": "Sales:",
  "34b9ee32d987": "Cleaning",
  "35588aa2c835": "Payroll run",
  "355bcc577d71": "Finished",
  "35f8f37b92ae": "Invoices",
  "36155d48f460": "Equipment",
  "36bd682e26f2": "Active Workforce",
  "3703cd216881": "Health",
  "3800d43722bf": "Overtime end",
  "3843ff8c30a8": "Gross pay",
  "3a9c736b3175": "Rate",
  "3b088a8d029f": "Adjustment Reason:",
  "3b3d106c9d41": "Total Hrs",
  "3b906ae77c48": "— None —",
  "3ccdbf4d7f99": "Total on-farm time",
  "3d5c0698ff43": "Open employee monthly calendars with day-level attendance details and owner actions.",
  "3dd7d56a8ed3": "Export PDF",
  "3deb74565196": "Type",
  "3e98a6f0ad01": "Course name*",
  "4013e76802c8": "Date/Period",
  "4029af0ce98d": "Total Net",
  "4039d9ab8154": "Photo verification",
  "409bf9a68d39": "On Leave",
  "40a3ddbd053e": "BIR withholding tax",
  "41b81eb8db1b": "Approved",
  "41d2bfcb3221": "Enrolled",
  "4310ed540c1c": "Late",
  "4317a9f49f13": "On Break",
  "43ff2f873398": "Attendance status",
  "44445057411b": "· Daily Entries",
  "445214c59246": "Attendance Record Detail",
  "44f285821581": "Paid Lunch",
  "455277469acd": "Early Leave",
  "4614b24a3348": "OL:",
  "46f5a26023da": "Manual Override:",
  "484745909404": "Back to Attendance",
  "489f4877244a": "Score",
  "48a7b68e8254": "Dept",
  "49b22df6e989": "Loading shifts…",
  "49cc9506e074": "https://drive.google.com/…",
  "49ef7c7288c8": "Owner · Team",
  "4a245944efb6": "Export Excel",
  "4a8dbfe40169": "Overtime Management",
  "4b4cbf19953a": "Selected period:",
  "4c53f16bc00d": "Payroll Report",
  "4ce5336ea711": "Overtime Report",
  "4d56ca9be0c8": "Notes (optional)",
  "4d63c1d51940": "Cancel Edit",
  "4dfaf7a86dc1": "Assigned Areas",
  "4e9f7a31eef4": "Present",
  "4ec763aab4f8": "Feeding",
  "4ffa6666f3d0": "e.g. 12",
  "505b07c067ac": "Quick Calc",
  "50cc12f69e8f": "Unpaid",
  "50f88da05c8e": "Breaks",
  "5122ab8cc651": "My Timesheet",
  "5124fc39013f": "Supervisor Notes",
  "512a3bb93d16": "m running",
  "52011cda3e18": "Absent Report",
  "5226bf9ebf6a": "Assign to employee",
  "52d0b35277ee": "Rows",
  "5301648dcf6b": "Edit",
  "538b62aa5eee": "Total Deductions",
  "5393bd8aa99e": "Daily Logs",
  "5401ccefc6f1": "Manual correction of attendance timestamps with required reason for audit trail.",
  "54f25815e591": "No enrollments yet.",
  "5548ae4f34cb": "days",
  "554a6cb53109": "to see the breakdown.",
  "55bd39660c34": "Worked",
  "55f8ebc805e6": "Description",
  "56e3badc4e6c": "Refresh",
  "56f04191af49": "Field Tasks",
  "573c15f22edb": "13th month accrual",
  "5755f9ac0aa1": "Export CSV",
  "585ecb76103a": "Lunch",
  "58abf77397d3": "Enter a gross salary to see all deductions instantly.",
  "59a4e9d0dcd7": "e.g. Handover to Reyna",
  "59f0e720608e": "Late Report",
  "5a308463b948": "Float:",
  "5b221e9c2a45": "Print",
  "5b4a3dbd3cca": "Linked Login Account",
  "5bc584c57e22": "Estimated Gross Pay",
  "5beab2dda050": "Clock Out (ISO or HH:MM)",
  "5c3d268b79ed": "Approved Hours",
  "5c5c7b61fa6c": "Est OT Cost",
  "5c7113e38a37": "— Top level —",
  "5d9129ed27ec": "Total deductions",
  "5e04968b4f22": "Completed Attendance Record",
  "5e326b17d2aa": "Incidents",
  "5e629b9e6116": "Machinery inspections",
  "603a1d24ed40": "POS sales will still work but won't be attached to a cash drawer.",
  "60a83b2a7fc8": "Allowances",
  "6210825e9aee": "Pending OT Hrs",
  "636e86725f30": "Monthly Salary (",
  "63ac9ee9b150": "No employees",
  "63deca910cbd": "Trainer",
  "6403f2b7eb2a": "New",
  "64435fd82de7": "Float",
  "655fe3daa8e4": "Reports to",
  "661b80d237e8": "No linked account",
  "66257651cd9f": "Payroll Reports",
  "67933b628589": "PD",
  "684858dc58f7": "Biometric ID",
  "6865979bde8e": "· RFID",
  "687c82861c95": "Documents",
  "6881cf0ce1e8": "Pending OT",
  "68b06689017c": "Cash Sales",
  "69064d7e30fe": "Adjust Attendance Record",
  "69152ef3561d": "Excess break duration",
  "69bd4ef9fbd0": "View",
  "6ac87f344682": "Expected",
  "6b74bc75753a": "Owner Controls",
  "6beef1dfb098": "Regular Hours",
  "6c4f11cc0cc7": "Canonical attendance with approval workflow, calendar, timesheets, overtime, and reporting.",
  "6c869993528f": "Refresh Employees",
  "6cb0c2af765e": "Doc Type",
  "6d3aec5a7cf6": "Payslip Generator",
  "6e1ffb50d629": "Morning Break",
  "6ecc5900b43c": "MO",
  "6ecfc5f3c266": "No overtime requests for this period.",
  "6f919fae4c76": "Employee contributions",
  "6f9d99c836e1": "Total Sales",
  "70123096c2b1": "Overtime request status",
  "70440046a3dc": "Notes",
  "710ee282158a": "Overtime Hours",
  "71c29c587ed3": "My Payslip",
  "725998e1c936": "No completed attendance records available for the selected month.",
  "728298d3dbf4": "Daily",
  "72ca5ad1b7da": "Net Total",
  "72f1ae653d25": "Approved OT Hrs",
  "746fbf1fe9ce": "Calendar PDF",
  "74961325bb2e": "Employee Management",
  "751d98434e7f": "My Timesheet, Request Overtime, My Payslips, and My Payroll Summary.",
  "757bbae2b303": "Deductions",
  "77064d526523": "Phone",
  "777800dce2f6": "Regular Hrs",
  "77b373b71b38": "No login account linked.",
  "77dfd2135f4d": "Cancel",
  "78c072709400": "Cashier",
  "791415f1fe3b": "Assigned Species (for cost allocation)",
  "79cbc5eb672a": "Click",
  "7a3a9094b18c": "Open Calendar",
  "7a7e4f0979e8": "Employee Report",
  "7b156d6608a3": "Save Employee",
  "7b1c510683d9": "Add a role in the org chart. Leave “Reports to” empty for the top level.",
  "7b2c7f146aba": "Approve",
  "7b49076441ca": "Overtime start",
  "7ba0a4f030d1": "Pending Approval",
  "7c9a7c0610c1": "Detail",
  "7d41b8a01b3b": "P:",
  "7d521bd3eaf5": "HR & Training",
  "7d8b22804b5f": "Quick PH Payroll Calculator",
  "7dd2bff06693": "Attendance Management",
  "7f5e5b69c2ee": "Holiday Pay",
  "7f9bf082bf6a": "Clock Out",
  "7fae2e54bfad": "Close Shift · Z-Report",
  "80aa96da6777": "Payslips",
  "82b11cd1ea37": "Paid OT Cost",
  "8305cdfad2ff": "Approved overtime hours",
  "8324113fd693": "Attendance Summary",
  "837e09fce002": "Payroll (Philippines)",
  "856cf336058f": "Withholding tax",
  "86566cf7ad54": "Enrollments",
  "8659d5bb0656": "Employee ID (optional for owner/manager)",
  "8733b2d77b51": "Certificate URL",
  "879e32326c52": "Year",
  "87ab2daac1b7": "No positions yet. Create the top-level role first (leave “Reports to” empty).",
  "88c8d12b5663": "e.g. Farm Manager, Feeder, Vet Assistant",
  "88d86b7721d5": "Closed",
  "891ebccd5baa": "Lock",
  "8921cf0fbd0d": "Incident reports",
  "89e7a04b9eda": "Owner Module",
  "89f482351239": "EMP-001",
  "8ad7743ad473": "Pending Payroll",
  "8ba5bf47df7d": "Regular worked hours",
  "8bd5eb3853f4": "Enroll",
  "8c3ceb9d7a63": "Opening Float",
  "8c4cd1ca2a7f": "Not marked",
  "8c508c2e826b": "Template hash / device UID",
  "8c5b6be28fbd": "Employees",
  "8c73ae6a9e83": "Pending overtime hours",
  "8cc047ac17d3": "Approval",
  "8d3e921408c8": "Clock In",
  "8d669b0d0501": "Skills (comma-separated)",
  "8dcb2a02f748": "My Payroll Summary",
  "8e5903a8e4db": "Calculate",
  "8e6ff8d90e17": "Shift End (ISO or HH:MM)",
  "8f1f060b67a8": "A:",
  "8f3582ac4ca2": "Upload directly to Google Drive, or paste an existing Drive share link.",
  "8f7743c484f7": "Why overtime is needed",
  "8fcb7bac7bd8": "Pending Days",
  "905f63092ff2": "Sync",
  "90b257791180": "Absent Deduction",
  "90e239975959": "Period type",
  "917df91e1730": "Related",
  "92928c7b6205": "No rows for this report.",
  "93111a84e1f4": "My Payslips",
  "9364e8928195": "Roles · Daily attendance · Attendance-based payroll (current month).",
  "9416d69a3e82": "No shift open",
  "943d3bfeae70": "RFID Card #",
  "952f375412e8": "Start",
  "954ea97e382f": "Approved At",
  "957f629f801e": "View Calendar",
  "9580a6176fdb": "Gross",
  "9693aeaaf68e": "Duration:",
  "96e7788c79bd": "Courses (",
  "96f608c16cef": "Pending",
  "9752ec5ddc51": "Full breakdown of this cashier session with per-method totals.",
  "97c89a4d6630": "Action",
  "9845e4c7cbf9": "Employment Status",
  "98695f0daeb1": "Days Present",
  "9890885ac526": "Org Chart",
  "992e832bf95c": "Scheduled shift",
  "99f0f68fdb03": "Allowances (non-taxable)",
  "9abe23c2289e": "Clock In (ISO or HH:MM)",
  "9b864cbc52c7": "Human Resources",
  "9bb44178089c": "Enrollments (",
  "9bb81c2eccbe": "Net",
  "9c3befe7e22c": "Notes:",
  "9cb29e734a6c": "All Statuses",
  "9e519416153d": "Period start*",
  "9e9477eabd86": "Absent Today",
  "9f20399258fc": "Estimated Gross",
  "a0547a8e2033": "Summary PDF",
  "a08e11119aef": "Excel",
  "a16536d78dc3": "Courses",
  "a16920d0c9e8": "Payslip breakdown for the selected payroll period.",
  "a2bb9d34b8a1": "End",
  "a2d22fa79cfa": "Or paste Drive URL",
  "a369b490afc9": "Approval status",
  "a3c686e711e4": "Category",
  "a3d0e5f9ad0c": "working / finished / late / absent",
  "a3d15e89dcb8": "Dashboard, salary review, settings, payslips, history, and reports.",
  "a4b3b69b782a": "Approved hours",
  "a5a74a6df092": "Device",
  "a63f8fcba6a4": "Counted Cash",
  "a65de8bce998": "Assigned Area",
  "a733b809d2f1": "Active",
  "a7520b9f06a5": "Expected in Drawer",
  "a75db0499b89": "Net Pay",
  "a8231c45a592": "Break Hrs",
  "a8a08b39323e": "New Position",
  "a8d919de0525": "Hire Date",
  "a99be3da0c9d": "Expires",
  "aa49ea3a3849": "Count each payment method, we'll compute the variance vs expected.",
  "aa9bf183da8a": "No timesheet data for this month.",
  "ab166bd5e8c5": "Adjust",
  "ac1482c53106": "Afternoon Break",
  "ac746d1a1538": "New Payslip",
  "acf52fa41a9f": "No timesheet data available.",
  "adac69379a62": "Code",
  "b02b98e68182": "Photo count",
  "b13bdb89caf8": "Cost (₱)",
  "b188ce60e7b0": "By Payment Method",
  "b1a5fa6c1056": "/d",
  "b1e64785455f": "No documents yet.",
  "b278e65545af": "Payroll History",
  "b2ea2a0a4e72": "Gross Pay",
  "b3d7ace83eec": "Displayed in Asia/Manila timezone for operations review.",
  "b4753fad7c09": "Close Shift · Cash Drawer Count",
  "b49e92dddae0": "Break Start (ISO or HH:MM)",
  "b4ceeaaca95c": "My Payroll",
  "b4ebd03d7de2": "Shift End",
  "b50da595e41b": "Live Attendance",
  "b5441c89188d": "OT",
  "b5ea57b10f2e": "Download Z-Report PDF",
  "b624f2b953b2": "Select attendance record",
  "b6c935d4f3c7": "min",
  "b6fe7f5e7917": "Training",
  "b717b37f7007": "Milking, AI Insemination, Vaccination",
  "b74bdee9c34f": "Finish",
  "b758d32ce6c0": "Overtime",
  "b75eeb06c71c": "End-of-day notes",
  "b85b0d2563b0": "Back to Employee Management",
  "b8ce37a1915f": "End:",
  "ba4adca50018": "Late Min",
  "bae7d5be7082": "Status",
  "bc5af774c819": "AP",
  "bc628f9fdf5d": "e.g. 500",
  "bd2f8874cb1a": "Payroll Settings",
  "be059c99af08": "Add Document",
  "be064f5f0956": "Hours Worked (this month)",
  "be3d534838ef": "PhilHealth",
  "be3e73b1165d": "CLOSED",
  "c04cd537976c": "Bi-weekly",
  "c140767afa8d": "Employee Code",
  "c16e1abc1551": "Annual Balance",
  "c1b4d92cd3af": "Payroll Dashboard",
  "c2f8da1d24cf": "Excess minutes:",
  "c36f953ce513": "Shift Start",
  "c3b31b4e5d10": "Paid break duration",
  "c3b69e661eec": "Choose…",
  "c3cb315ce778": "Days Absent",
  "c44471c3a3f0": "e.g. BIO-A47F92",
  "c4551e54f944": "Present Days",
  "c4f1f5b1d49f": "Opened",
  "c530d39862c2": "Reason for adjustment *",
  "c531413f369b": "Submit Overtime Request",
  "c70d7c3ad58f": "Time Summary",
  "c89f591ea418": "Unpaid lunch duration",
  "c915f1de7864": "No employees found.",
  "c932ce9dd0d2": "Short Shifts",
  "cafacb251b01": "Net Salary",
  "cb880d37b1d5": "Overtime Hrs",
  "cc7255c7835c": "Select approved login account",
  "cd4683fadf70": "Positions",
  "ce83e89cd164": "Reset Today",
  "cf25e1aabf83": "Late Deduction",
  "cf9b77061f7b": "Open",
  "cfea419c3b4e": "Apply",
  "d01d900383e4": "Photo",
  "d03550660873": "Requested OT",
  "d0edfb6e8c55": "Sales",
  "d1f7dc891b5e": "Timezone",
  "d219c68101f5": "Location",
  "d31edb7b8a94": "Monthly",
  "d34807437ad4": "Enter gross pay + allowances; click Calculate to auto-compute PH statutory deductions.",
  "d35ccc935460": "No courses yet.",
  "d3851cd5a3ba": "Linked:",
  "d45987441aa0": "Payroll",
  "d49aff000867": "Leave Management",
  "d613d88cb2d8": "PDF",
  "d69c2f962e2b": "For time-clock check-in devices, RFID gates and payroll audit trail.",
  "d70f93df5e8f": "Address",
  "d780da02aeb5": "Validity (months)",
  "d79756af148d": "OT Pay",
  "d7b19b13afed": "Save Payslip",
  "d8eb2cd577f1": "Shift Open ·",
  "d921a79afac4": "Uploading…",
  "d9ad7bd07d54": "Paid Morning Break",
  "da450df06c38": "ADJ",
  "da4a2c39af98": "Withholding Tax",
  "da4c89e6e92c": "Cash Drawer",
  "da5a77213322": "Cleaning records",
  "da76a7170f8f": "OT Hrs",
  "db40106a4051": "Department",
  "db83dc176235": "Title*",
  "dbded5c557db": "Pag-IBIG 2%",
  "dc055296f9b5": "Days Late",
  "dc21d2b4eede": "Arrival",
  "dc224b39292d": "Livestock, Crops, Admin…",
  "dc7ac0ea52d3": "Farm timezone: Asia/Manila (Philippine Time)",
  "dc9d4584a554": "Paid",
  "ddcb77ff769e": "Load",
  "de46fd99bf8c": "Search name, email, or role",
  "deaa3bd8c746": "Daily attendance rows used to compute selected timesheet totals.",
  "deb5d5e2f038": "Issued",
  "debd5dae9f6b": "Allowed duration:",
  "e070de224434": "Currency",
  "e0d973c01708": "Night Diff",
  "e144f64b4481": "Bonuses",
  "e148523dfcef": "Pag-IBIG",
  "e2ba856d207e": "Link this employee to an approved authenticated account for Field Mode and attendance identity resolution.",
  "e38e46045f4a": "Upload file to Google Drive",
  "e3e63f75b4ce": "LCK",
  "e80a55ae1d1c": "e.g. 2",
  "e855dc6c9f6a": "Fingerprint Template ID (opaque)",
  "e8c2bdd8592c": "Org chart, employee documents and training records.",
  "e8d8c8b178a1": "Biometric enrolled",
  "e92452c8d3e2": "Absent",
  "e92ffaf3bfae": "Paid Afternoon Break",
  "e9e0ceb5e814": "/mo",
  "eb39bbf6ccbb": "Variance",
  "eb672cb3ba02": "All Types",
  "eb9a4bc1c0c1": "Date",
  "ec016bec26f8": "Store the biometric device's template ID here (not the raw fingerprint). Raw biometric data should NEVER leave the enrollment device — this app only stores a reference so time-clock hardware can match on-device.",
  "ef4485a7d9ed": "Farm timezone",
  "efc007a393f6": "Save",
  "f00f0a0d2a65": "Requested At",
  "f130609dfc13": "Custom Range",
  "f219cc0614ae": "Reason",
  "f39e8bce1e61": "Download payslip PDF",
  "f4f29aecc894": "No payslips yet.",
  "f5dc67c95488": "SSS",
  "f5dec71ed241": "Other Deductions",
  "f66d88d1c09a": "All Departments",
  "f6bb0f468a85": "Days",
  "f6d5e7fd47b8": "L:",
  "f6fdbe48dc54": "Delete",
  "f7194e6a0d0b": "Requests",
  "f78768694337": "Open, close, and audit every cashier session. Z-reports downloadable as PDF.",
  "f7fc105d02b9": "Pen 1, Coop A",
  "f81283ceb61e": "Break End",
  "f831df50d6d4": "Other deductions",
  "fa70e8a6cdcb": "Gross Total",
  "fb9c60d73c33": "Requested Overtime Hours",
  "fbedf71452eb": "View Attendance",
  "fca4ca652254": "Health inspections",
  "fca608e68261": "New Payroll Run",
  "fdb013e14248": "Request Overtime",
  "fe3d54900d91": "Daily Rate",
  "ff3d88f9cf07": "Period end*"
};

export const batch1Tl = {
  "00040bab8a78": "Trabaho",
  "0022a3e10caa": "I-save ang Settings",
  "00eb6118aa8c": "Simula Selling",
  "00ef3a724f65": "Bilangin ang bawat paraan ng pagbabayad at ilagay ang nakitang halaga:",
  "01df8e3c852a": "Orphan (natanggal ang parent)",
  "01f09d033582": "Empleyado*",
  "029b40abb2b1": "e.g. 0004829145",
  "03781ceef83d": "Pumili a completed attendance record",
  "03e2ba65ef8e": "Walang available na payslip para sa buwang ito.",
  "042c862e4467": "Subukan muli",
  "048188f452d4": "Payroll Ngayong Buwan",
  "05882967d7f8": "Present Ngayon",
  "05b1368a3a3a": "Aprubado OT",
  "06709170d095": "Minutong Late",
  "06ad8947fca5": "Inaasahang Cash",
  "0755a0dcc6b2": "e.g. 30000",
  "0755e0e4e2bd": "Detalyadong timeline at katayuan ng attendance ng empleyado, kasama ang mga pag-apruba ng owner.",
  "0756876bdffa": "Buong Pangalan *",
  "075d521f7323": "Aprubadong Araw",
  "0764e6ebae1b": "Tinatayang Bayad",
  "0789dc9c5a6a": "Panimulang float (cash sa drawer sa simula)",
  "079711ea16f3": "Empleyado",
  "07fcdbd896a2": "Kabuuang Empleyado",
  "08189b0386c8": "Kasalukuyang Nagtatrabaho",
  "082bc378cd60": "Buwan",
  "08aeea7adb7f": "inv)",
  "08ca0722e1e6": "Bawiin ang biometric",
  "092f9dd0a820": "Isara & I-save Z-Ulat",
  "09509cdf6759": "Buksan ang Shift",
  "0999bb9a8a81": "Minuto ng maagang pag-uwi",
  "0ac1f92dafde": "Aking Attendance",
  "0bc42f0bd0f1": "Employer share (SSS+PH+HDMF)",
  "0c56dbea8b56": "Walang leave request para sa filter na ito.",
  "0c5bc1ae01ce": "Mga Shift",
  "0c63e27ff3bc": "Biometric / Access Credentials",
  "0cf1f544b8e0": "GPS/location",
  "0d16c6e19d1f": "Emergency Contact",
  "0e7b9960126c": "Override Dahilan:",
  "0fd159793490": "Gross na Benta",
  "10dca9add4f6": "Maghanap name, role, department, code…",
  "134fad54d6c5": "· exp",
  "156ce256cf91": "Walang live attendance record para sa petsang ito.",
  "158f3da59275": "Lingguhan",
  "170a28a9db6d": "Panahon",
  "174a464e2022": "I-save ang Pag-aayos",
  "1776fa32f23e": "GPS",
  "1798b3ba42ee": "Tapos na",
  "18e10e9e589f": "Bagong Empleyado",
  "1929b59a2c7a": "Mga Empleyado with Payroll Activity",
  "1a043363d06f": "Arawang Attendance Details ·",
  "1af75126f6bf": "Pumili ng file",
  "1b485b9e171b": "Mga Timesheet",
  "1b60380406cd": "Nakatakdang lugar",
  "1c7c77b27543": "Simula:",
  "1c9a7a0c6e70": "Maghanap ng empleyado",
  "1d1a6f070303": "Manwal na Override",
  "1d55271669a9": "Performance Score (0-100)",
  "1e2c05f5bacd": "Walang shifts yet. Buksan your first shift from the POS page.",
  "1e62856f241a": "Walang attendance log sa saklaw na ito.",
  "1f77e83907c4": "Pumili...",
  "220e06ba2fee": "Out",
  "2277adf26882": "Role / Posisyon *",
  "231bdaee7939": "Kurso*",
  "237003634970": "Pagsusuri ng Payroll",
  "23bd7dfc67c2": "Employee ID",
  "23d0c59c035a": "Mga Saradong Shift",
  "24345a14377f": "Ngayon",
  "24b572840e97": "Kaligtasan sa Bukid, Paraan ng Pagbabakuna…",
  "24ce812e7163": "Natapos na Trabaho",
  "2602fe1c7df1": "Buwanang gross pay (₱)",
  "26ede189a778": "Orasang Rate",
  "27848f34b1ed": "Bayad batay sa attendance ·",
  "27d5482eebd0": "h",
  "27d9f7d0f448": "Break End (ISO or HH:MM)",
  "27eeb7a291bf": "Tinanggihan",
  "29353c2b2528": "Buwanang Sahod",
  "2a206d915208": "Natapos na mga gawain sa Field Mode",
  "2ac82da485ed": "Kabuuang Team",
  "2af30b2cf622": "Tala sa pag-apruba",
  "2b03b59293b6": "Tanggihan",
  "2c32db022782": "Kumpletong arawang buod ng attendance, pagkalkula ng break, overtime, at mga kontrol ng owner.",
  "2c3cafa4db3f": "File",
  "2d350acabd06": "Attendance ID:",
  "2db74df2c056": "e.g. Morning shift, refilled coins",
  "2dd1098a9b10": "Buksan POS Shift",
  "2ddd2d78ecfb": "Ulat ng Leave",
  "2f905322013e": "Detalye ng Shift",
  "2f9a6ef20587": "PhilHealth 2.5%",
  "2fdc620768b1": "Markahan bilang naka-enroll",
  "2fe22cb4982c": "NET PAY",
  "300b6ef0cdd8": "Uri ng dokumento",
  "3168162b6ccd": "Mga Rate ng Sahod ng Empleyado",
  "3174c06b9dad": "Naipong 13th Month Pay",
  "3197cbcce5dd": "Mga Ulat ng Attendance",
  "3198fe550382": "Gross basic pay (₱)*",
  "319a2b6e851d": "Nabilang",
  "31b1667fa635": "Kasalukuyang Bukas",
  "31d4ba32a2e0": "Hiniling hours",
  "31e6ef3947c6": "Simula ng Break",
  "327b7992b55e": "Minutong late",
  "33906a7dfdec": "OPEN",
  "33bbad56533f": "Mga tala ng pagpapakain",
  "33ce417454bf": "Naglo-load…",
  "34115ad627a6": "Development Mode: Pinapayagan ang pag-reset ng attendance ngayong araw para sa Owner/Admin testing.",
  "34465c52157a": "Payslip",
  "346714c46c07": "Kalendaryo ng Empleyado",
  "34a4dd3cb9f3": "Sales:",
  "34b9ee32d987": "Paglilinis",
  "35588aa2c835": "Payroll run",
  "355bcc577d71": "Tapos",
  "35f8f37b92ae": "Invoices",
  "36155d48f460": "Equipment",
  "36bd682e26f2": "Aktibong Workforce",
  "3703cd216881": "Kalusugan",
  "3800d43722bf": "Pagtatapos ng overtime",
  "3843ff8c30a8": "Gross pay",
  "3a9c736b3175": "Rate",
  "3b088a8d029f": "Dahilan ng Pag-aayos:",
  "3b3d106c9d41": "Kabuuang Hrs",
  "3b906ae77c48": "— Wala —",
  "3ccdbf4d7f99": "Kabuuang on-farm time",
  "3d5c0698ff43": "Buksan ang buwanang kalendaryo ng empleyado na may arawang detalye ng attendance at mga aksyon ng owner.",
  "3dd7d56a8ed3": "I-export sa PDF",
  "3deb74565196": "Uri",
  "3e98a6f0ad01": "Pangalan ng kurso*",
  "4013e76802c8": "Petsa/Panahon",
  "4029af0ce98d": "Kabuuang Net",
  "4039d9ab8154": "Pag-verify ng larawan",
  "409bf9a68d39": "Naka-leave",
  "40a3ddbd053e": "BIR withholding tax",
  "41b81eb8db1b": "Aprubado",
  "41d2bfcb3221": "Naka-enroll",
  "4310ed540c1c": "Late",
  "4317a9f49f13": "Naka-break",
  "43ff2f873398": "Katayuan ng attendance",
  "44445057411b": "· Arawang Entries",
  "445214c59246": "Detalye ng Attendance Record",
  "44f285821581": "Bayad na Tanghalian",
  "455277469acd": "Maagang Pag-uwi",
  "4614b24a3348": "OL:",
  "46f5a26023da": "Manual Override:",
  "484745909404": "Bumalik sa Attendance",
  "489f4877244a": "Score",
  "48a7b68e8254": "Dept",
  "49b22df6e989": "Nilo-load ang mga shift…",
  "49cc9506e074": "https://drive.google.com/…",
  "49ef7c7288c8": "Owner · Team",
  "4a245944efb6": "I-export sa Excel",
  "4a8dbfe40169": "Pamamahala ng Overtime",
  "4b4cbf19953a": "Napiling period:",
  "4c53f16bc00d": "Ulat ng Payroll",
  "4ce5336ea711": "Ulat ng Overtime",
  "4d56ca9be0c8": "Mga Tala (opsyonal)",
  "4d63c1d51940": "Kanselahin ang Pag-edit",
  "4dfaf7a86dc1": "Mga Nakatakdang Lugar",
  "4e9f7a31eef4": "Present",
  "4ec763aab4f8": "Pagpapakain",
  "4ffa6666f3d0": "e.g. 12",
  "505b07c067ac": "Mabilisang Kalkulasyon",
  "50cc12f69e8f": "Hindi Bayad",
  "50f88da05c8e": "Mga Break",
  "5122ab8cc651": "Aking Timesheet",
  "5124fc39013f": "Supervisor Mga Tala",
  "512a3bb93d16": "m running",
  "52011cda3e18": "Ulat ng Pagliban",
  "5226bf9ebf6a": "Italaga sa empleyado",
  "52d0b35277ee": "Rows",
  "5301648dcf6b": "I-edit",
  "538b62aa5eee": "Kabuuang Bawas",
  "5393bd8aa99e": "Araw-araw na Log",
  "5401ccefc6f1": "Manwal na pagwawasto ng oras ng attendance na may kinakailangang dahilan para sa audit trail.",
  "54f25815e591": "Wala pang enrollment.",
  "5548ae4f34cb": "mga araw",
  "554a6cb53109": "para makita ang detalye.",
  "55bd39660c34": "Nagtrabaho",
  "55f8ebc805e6": "Paglalarawan",
  "56e3badc4e6c": "I-refresh",
  "56f04191af49": "Mga Gawain sa Field",
  "573c15f22edb": "Naipong 13th month pay",
  "5755f9ac0aa1": "I-export sa CSV",
  "585ecb76103a": "Tanghalian",
  "58abf77397d3": "Ilagay ang gross salary upang makita agad ang lahat ng bawas.",
  "59a4e9d0dcd7": "e.g. Handover to Reyna",
  "59f0e720608e": "Ulat ng Pagka-late",
  "5a308463b948": "Float:",
  "5b221e9c2a45": "I-print",
  "5b4a3dbd3cca": "Naka-link na Login Account",
  "5bc584c57e22": "Tinatayang Gross Pay",
  "5beab2dda050": "Clock Out (ISO or HH:MM)",
  "5c3d268b79ed": "Aprubadong Oras",
  "5c5c7b61fa6c": "Tinatayang Gastos sa OT",
  "5c7113e38a37": "— Pinakamataas na antas —",
  "5d9129ed27ec": "Kabuuang deductions",
  "5e04968b4f22": "Kumpletong Attendance Record",
  "5e326b17d2aa": "Incidents",
  "5e629b9e6116": "Mga inspeksyon ng makinarya",
  "603a1d24ed40": "Gagana pa rin ang POS sales ngunit hindi ito maiuugnay sa cash drawer.",
  "60a83b2a7fc8": "Mga Allowance",
  "6210825e9aee": "Nakabinbin OT Hrs",
  "636e86725f30": "Buwanang Salary (",
  "63ac9ee9b150": "Walang empleyado",
  "63deca910cbd": "Trainer",
  "6403f2b7eb2a": "Bago",
  "64435fd82de7": "Float",
  "655fe3daa8e4": "Nagre-report kay",
  "661b80d237e8": "Walang naka-link na account",
  "66257651cd9f": "Mga Ulat ng Payroll",
  "67933b628589": "PD",
  "684858dc58f7": "Biometric ID",
  "6865979bde8e": "· RFID",
  "687c82861c95": "Mga Dokumento",
  "6881cf0ce1e8": "Nakabinbin OT",
  "68b06689017c": "Cash na Benta",
  "69064d7e30fe": "Ayusin ang Attendance Record",
  "69152ef3561d": "Sobrang tagal ng break",
  "69bd4ef9fbd0": "Tingnan",
  "6ac87f344682": "Inaasahan",
  "6b74bc75753a": "Mga Kontrol ng Owner",
  "6beef1dfb098": "Regular na Oras",
  "6c4f11cc0cc7": "Opisyal na attendance na may approval workflow, kalendaryo, timesheet, overtime, at mga ulat.",
  "6c869993528f": "I-refresh ang mga Empleyado",
  "6cb0c2af765e": "Doc Type",
  "6d3aec5a7cf6": "Payslip Generator",
  "6e1ffb50d629": "Umagang Break",
  "6ecc5900b43c": "MO",
  "6ecfc5f3c266": "Walang overtime request para sa panahong ito.",
  "6f919fae4c76": "Empleyado contributions",
  "6f9d99c836e1": "Kabuuang Sales",
  "70123096c2b1": "Katayuan ng overtime request",
  "70440046a3dc": "Mga Tala",
  "710ee282158a": "Oras ng Overtime",
  "71c29c587ed3": "Aking Payslip",
  "725998e1c936": "Walang kumpletong attendance record para sa napiling buwan.",
  "728298d3dbf4": "Araw-araw",
  "72ca5ad1b7da": "Net Kabuuang",
  "72f1ae653d25": "Aprubado OT Hrs",
  "746fbf1fe9ce": "Calendar PDF",
  "74961325bb2e": "Pamamahala ng Empleyado",
  "751d98434e7f": "Aking Timesheet, Kahilingan sa Overtime, mga Payslip, at Buod ng Payroll.",
  "757bbae2b303": "Mga Bawas",
  "77064d526523": "Telepono",
  "777800dce2f6": "Regular Hrs",
  "77b373b71b38": "Walang naka-link na login account.",
  "77dfd2135f4d": "Kanselahin",
  "78c072709400": "Cashier",
  "791415f1fe3b": "Nakatakdang species (para sa paghahati ng gastos)",
  "79cbc5eb672a": "I-click",
  "7a3a9094b18c": "Buksan ang Kalendaryo",
  "7a7e4f0979e8": "Ulat ng Empleyado",
  "7b156d6608a3": "I-save ang Empleyado",
  "7b1c510683d9": "Magdagdag ng a role in the org chart. Leave “Mga Ulat to” empty for the top level.",
  "7b2c7f146aba": "Aprubahan",
  "7b49076441ca": "Simula ng overtime",
  "7ba0a4f030d1": "Naghihintay ng Pag-apruba",
  "7c9a7c0610c1": "Detalye",
  "7d41b8a01b3b": "P:",
  "7d521bd3eaf5": "HR at Training",
  "7d8b22804b5f": "Mabilisang PH Payroll Calculator",
  "7dd2bff06693": "Pamamahala ng Attendance",
  "7f5e5b69c2ee": "Bayad sa Holiday",
  "7f9bf082bf6a": "Clock Out",
  "7fae2e54bfad": "Isara Shift · Z-Ulat",
  "80aa96da6777": "Mga Payslip",
  "82b11cd1ea37": "Gastos sa Bayad na OT",
  "8305cdfad2ff": "Aprubadong oras ng overtime",
  "8324113fd693": "Buod ng Attendance",
  "837e09fce002": "Payroll (Pilipinas)",
  "856cf336058f": "Withholding tax",
  "86566cf7ad54": "Mga Enrollment",
  "8659d5bb0656": "Employee ID (opsyonal para sa owner/manager)",
  "8733b2d77b51": "Certificate URL",
  "879e32326c52": "Taon",
  "87ab2daac1b7": "Walang positions yet. Create the top-level role first (leave “Mga Ulat to” empty).",
  "88c8d12b5663": "e.g. Farm Manager, Feeder, Vet Assistant",
  "88d86b7721d5": "Sarado",
  "891ebccd5baa": "I-lock",
  "8921cf0fbd0d": "Mga Ulat ng Insidente",
  "89e7a04b9eda": "Owner Module",
  "89f482351239": "EMP-001",
  "8ad7743ad473": "Nakabinbin Payroll",
  "8ba5bf47df7d": "Regular na oras na nagtrabaho",
  "8bd5eb3853f4": "I-enroll",
  "8c3ceb9d7a63": "Panimulang Float",
  "8c4cd1ca2a7f": "Hindi namarkahan",
  "8c508c2e826b": "Template hash / device UID",
  "8c5b6be28fbd": "Mga Empleyado",
  "8c73ae6a9e83": "Nakabinbin overtime hours",
  "8cc047ac17d3": "Pag-apruba",
  "8d3e921408c8": "Clock In",
  "8d669b0d0501": "Mga kasanayan (paghiwalayin ng kuwit)",
  "8dcb2a02f748": "Buod ng Aking Payroll",
  "8e5903a8e4db": "Kalkulahin",
  "8e6ff8d90e17": "Shift End (ISO or HH:MM)",
  "8f1f060b67a8": "A:",
  "8f3582ac4ca2": "I-upload directly to Google Drive, or paste an existing Drive share link.",
  "8f7743c484f7": "Bakit kailangan ang overtime",
  "8fcb7bac7bd8": "Nakabinbin Mga Araw",
  "905f63092ff2": "Sync",
  "90b257791180": "Bawas dahil sa pagliban",
  "90e239975959": "Uri ng period",
  "917df91e1730": "Related",
  "92928c7b6205": "Walang rows for this report.",
  "93111a84e1f4": "Aking mga Payslip",
  "9364e8928195": "Roles · Arawang attendance · Attendance-based payroll (current month).",
  "9416d69a3e82": "Walang bukas na shift",
  "943d3bfeae70": "RFID Card #",
  "952f375412e8": "Simula",
  "954ea97e382f": "Aprubado At",
  "957f629f801e": "Tingnan ang Kalendaryo",
  "9580a6176fdb": "Gross",
  "9693aeaaf68e": "Tagal:",
  "96e7788c79bd": "Courses (",
  "96f608c16cef": "Nakabinbin",
  "9752ec5ddc51": "Kumpletong detalye ng cashier session na ito at kabuuan sa bawat paraan ng pagbabayad.",
  "97c89a4d6630": "Aksyon",
  "9845e4c7cbf9": "Katayuan sa Trabaho",
  "98695f0daeb1": "Mga Araw na Present",
  "9890885ac526": "Org Chart",
  "992e832bf95c": "Nakatakdang shift",
  "99f0f68fdb03": "Mga Allowance (hindi taxable)",
  "9abe23c2289e": "Clock In (ISO or HH:MM)",
  "9b864cbc52c7": "Human Resources",
  "9bb44178089c": "Enrollments (",
  "9bb81c2eccbe": "Net",
  "9c3befe7e22c": "Mga Tala:",
  "9cb29e734a6c": "Lahat ng Katayuan",
  "9e519416153d": "Simula ng period*",
  "9e9477eabd86": "Absent Ngayon",
  "9f20399258fc": "Tinatayang Gross",
  "a0547a8e2033": "Summary PDF",
  "a08e11119aef": "Excel",
  "a16536d78dc3": "Mga Kurso",
  "a16920d0c9e8": "Detalye ng payslip para sa napiling payroll period.",
  "a2bb9d34b8a1": "Pagtatapos",
  "a2d22fa79cfa": "O i-paste ang Drive URL",
  "a369b490afc9": "Katayuan ng pag-apruba",
  "a3c686e711e4": "Kategorya",
  "a3d0e5f9ad0c": "nagtatrabaho / tapos / late / absent",
  "a3d15e89dcb8": "Dashboard, pagsusuri ng sahod, settings, payslip, kasaysayan, at mga ulat.",
  "a4b3b69b782a": "Aprubado hours",
  "a5a74a6df092": "Device",
  "a63f8fcba6a4": "Nabilang na Cash",
  "a65de8bce998": "Nakatakdang Lugar",
  "a733b809d2f1": "Aktibo",
  "a7520b9f06a5": "Inaasahan sa Drawer",
  "a75db0499b89": "Net Pay",
  "a8231c45a592": "Oras ng Break",
  "a8a08b39323e": "Bagong Posisyon",
  "a8d919de0525": "Petsa ng Pag-hire",
  "a99be3da0c9d": "Mag-e-expire",
  "aa49ea3a3849": "Bilangin ang bawat paraan ng pagbabayad; awtomatikong kakalkulahin ang diperensya sa inaasahan.",
  "aa9bf183da8a": "Walang timesheet data para sa buwang ito.",
  "ab166bd5e8c5": "Ayusin",
  "ac1482c53106": "Hapong Break",
  "ac746d1a1538": "Bagong Payslip",
  "acf52fa41a9f": "Walang available na timesheet data.",
  "adac69379a62": "Code",
  "b02b98e68182": "Bilang ng larawan",
  "b13bdb89caf8": "Gastos (₱)",
  "b188ce60e7b0": "Ayon sa Paraan ng Pagbabayad",
  "b1a5fa6c1056": "/d",
  "b1e64785455f": "Wala pang dokumento.",
  "b278e65545af": "Kasaysayan ng Payroll",
  "b2ea2a0a4e72": "Gross Pay",
  "b3d7ace83eec": "Ipinapakita sa Asia/Manila timezone para sa pagsusuri ng operasyon.",
  "b4753fad7c09": "Isara Shift · Cash Drawer Count",
  "b49e92dddae0": "Break Start (ISO or HH:MM)",
  "b4ceeaaca95c": "Aking Payroll",
  "b4ebd03d7de2": "Pagtatapos ng Shift",
  "b50da595e41b": "Live Attendance",
  "b5441c89188d": "OT",
  "b5ea57b10f2e": "I-download ang Z-Report PDF",
  "b624f2b953b2": "Pumili attendance record",
  "b6c935d4f3c7": "min",
  "b6fe7f5e7917": "Training",
  "b717b37f7007": "Paggagatas, AI Insemination, Pagbabakuna",
  "b74bdee9c34f": "Tapusin",
  "b758d32ce6c0": "Overtime",
  "b75eeb06c71c": "Pagtatapos-of-day notes",
  "b85b0d2563b0": "Bumalik sa Pamamahala ng Empleyado",
  "b8ce37a1915f": "Pagtatapos:",
  "ba4adca50018": "Late Min",
  "bae7d5be7082": "Katayuan",
  "bc5af774c819": "AP",
  "bc628f9fdf5d": "e.g. 500",
  "bd2f8874cb1a": "Mga Setting ng Payroll",
  "be059c99af08": "Magdagdag ng Document",
  "be064f5f0956": "Oras Worked (this month)",
  "be3d534838ef": "PhilHealth",
  "be3e73b1165d": "CLOSED",
  "c04cd537976c": "Kada dalawang linggo",
  "c140767afa8d": "Code ng Empleyado",
  "c16e1abc1551": "Taunang Balanse",
  "c1b4d92cd3af": "Payroll Dashboard",
  "c2f8da1d24cf": "Sobrang minuto:",
  "c36f953ce513": "Simula ng Shift",
  "c3b31b4e5d10": "Tagal ng bayad na break",
  "c3b69e661eec": "Pumili…",
  "c3cb315ce778": "Mga Araw na Absent",
  "c44471c3a3f0": "e.g. BIO-A47F92",
  "c4551e54f944": "Mga Araw na Present",
  "c4f1f5b1d49f": "Binuksan",
  "c530d39862c2": "Dahilan for adjustment *",
  "c531413f369b": "Isumite ang Kahilingan sa Overtime",
  "c70d7c3ad58f": "Buod ng Oras",
  "c89f591ea418": "Tagal ng hindi bayad na tanghalian",
  "c915f1de7864": "Walang nakitang empleyado.",
  "c932ce9dd0d2": "Maiikling Shift",
  "cafacb251b01": "Netong Sahod",
  "cb880d37b1d5": "Overtime Hrs",
  "cc7255c7835c": "Pumili approved login account",
  "cd4683fadf70": "Mga Posisyon",
  "ce83e89cd164": "I-reset ang Ngayon",
  "cf25e1aabf83": "Bawas dahil sa Pagka-late",
  "cf9b77061f7b": "Bukas",
  "cfea419c3b4e": "Ilapat",
  "d01d900383e4": "Larawan",
  "d03550660873": "Hiniling OT",
  "d0edfb6e8c55": "Sales",
  "d1f7dc891b5e": "Timezone",
  "d219c68101f5": "Lokasyon",
  "d31edb7b8a94": "Buwanan",
  "d34807437ad4": "Ilagay ang gross pay at allowance; i-click ang Kalkulahin para awtomatikong makuha ang mga statutory deduction sa Pilipinas.",
  "d35ccc935460": "Wala pang kurso.",
  "d3851cd5a3ba": "Naka-link:",
  "d45987441aa0": "Payroll",
  "d49aff000867": "Pamamahala ng Leave",
  "d613d88cb2d8": "PDF",
  "d69c2f962e2b": "Para sa time-clock device, RFID gate, at payroll audit trail.",
  "d70f93df5e8f": "Address",
  "d780da02aeb5": "Bisa (mga buwan)",
  "d79756af148d": "OT Pay",
  "d7b19b13afed": "I-save ang Payslip",
  "d8eb2cd577f1": "Shift Buksan ·",
  "d921a79afac4": "Nag-a-upload…",
  "d9ad7bd07d54": "Bayad na Umagang Break",
  "da450df06c38": "ADJ",
  "da4a2c39af98": "Withholding Tax",
  "da4c89e6e92c": "Cash Drawer",
  "da5a77213322": "Mga tala ng paglilinis",
  "da76a7170f8f": "OT Hrs",
  "db40106a4051": "Departamento",
  "db83dc176235": "Title*",
  "dbded5c557db": "Pag-IBIG 2%",
  "dc055296f9b5": "Mga Araw na Late",
  "dc21d2b4eede": "Pagdating",
  "dc224b39292d": "Livestock, Pananim, Admin…",
  "dc7ac0ea52d3": "Timezone ng bukid: Asia/Manila (Oras sa Pilipinas)",
  "dc9d4584a554": "Bayad",
  "ddcb77ff769e": "I-load",
  "de46fd99bf8c": "Maghanap name, email, or role",
  "deaa3bd8c746": "Mga arawang attendance row na ginagamit sa pagkalkula ng napiling timesheet totals.",
  "deb5d5e2f038": "Inisyu",
  "debd5dae9f6b": "Pinapayagang tagal:",
  "e070de224434": "Pera",
  "e0d973c01708": "Night Differential",
  "e144f64b4481": "Mga Bonus",
  "e148523dfcef": "Pag-IBIG",
  "e2ba856d207e": "I-link ang empleyadong ito sa aprubadong account para sa Field Mode at tamang pagkilala sa attendance.",
  "e38e46045f4a": "I-upload file to Google Drive",
  "e3e63f75b4ce": "LCK",
  "e80a55ae1d1c": "e.g. 2",
  "e855dc6c9f6a": "Fingerprint Template ID (opaque)",
  "e8c2bdd8592c": "Org chart, dokumento ng empleyado, at mga tala ng training.",
  "e8d8c8b178a1": "Naka-enroll ang biometric",
  "e92452c8d3e2": "Absent",
  "e92ffaf3bfae": "Bayad na Hapong Break",
  "e9e0ceb5e814": "/mo",
  "eb39bbf6ccbb": "Diperensya",
  "eb672cb3ba02": "Lahat ng Uri",
  "eb9a4bc1c0c1": "Petsa",
  "ec016bec26f8": "Ilagay rito ang template ID ng biometric device, hindi ang mismong fingerprint. Hindi dapat umalis sa enrollment device ang raw biometric data—reference lamang ang itinatago ng app para makapagtugma ang time-clock hardware sa device.",
  "ef4485a7d9ed": "Timezone ng Bukid",
  "efc007a393f6": "I-save",
  "f00f0a0d2a65": "Hiniling At",
  "f130609dfc13": "Pasadyang Saklaw",
  "f219cc0614ae": "Dahilan",
  "f39e8bce1e61": "I-download ang payslip PDF",
  "f4f29aecc894": "Wala pang payslip.",
  "f5dc67c95488": "SSS",
  "f5dec71ed241": "Iba pang Bawas",
  "f66d88d1c09a": "Lahat ng Departamento",
  "f6bb0f468a85": "Mga Araw",
  "f6d5e7fd47b8": "L:",
  "f6fdbe48dc54": "Tanggalin",
  "f7194e6a0d0b": "Mga Kahilingan",
  "f78768694337": "Buksan, isara, at suriin ang bawat cashier session. Maaaring i-download ang Z-report bilang PDF.",
  "f7fc105d02b9": "Pen 1, Coop A",
  "f81283ceb61e": "Pagtatapos ng Break",
  "f831df50d6d4": "Iba pang bawas",
  "fa70e8a6cdcb": "Gross Kabuuang",
  "fb9c60d73c33": "Hiniling na Oras ng Overtime",
  "fbedf71452eb": "Tingnan ang Attendance",
  "fca4ca652254": "Mga inspeksyon sa kalusugan",
  "fca608e68261": "Bagong Payroll Run",
  "fdb013e14248": "Humiling ng Overtime",
  "fe3d54900d91": "Arawang Rate",
  "ff3d88f9cf07": "Pagtatapos ng period*"
};
